import CryptoJS from "crypto-js";

export function base64Encode(str) {
  const encrypted = CryptoJS.enc.Utf8.parse(str); // 将输入转换为WordArray格式
  return CryptoJS.enc.Base64.stringify(encrypted); // 返回Base64格式的结果
}
//var hash = CryptoJS.HmacSHA256("Message", "Secret Passphrase");
export function hmacSHAsign(key, str) {
  const encrypted = CryptoJS.HmacSHA256(str, key);
  return CryptoJS.enc.Base64.stringify(encrypted); // 返回Base64格式的结果
}



// WEBPACK FOOTER //
// ./src/utils/encrypt.js